import TabbedTableBlock from './tabbedTableBlock'

export default TabbedTableBlock
